export interface WizardModule {
  id: string;
  code: string;
  name: string;
  status: 'existing' | 'new' | 'mandatory';
  badge: 'included' | 'selected' | 'available' | 'trial';
  description: string;
  price: string;
  iconBg: string;
  iconColor: string;
  iconClass: string;
}

export interface WizardIntegration {
  id: string;
  name: string;
  category: string;
  description: string;
  logoClass: string;
  logoBg: string;
  logoColor: string;
  connected: boolean;
  recommended: boolean;
}

export const wizardModules: WizardModule[] = [
  {
    id: 'core',
    code: 'M-00',
    name: 'Core',
    status: 'mandatory',
    badge: 'included',
    description: 'IAM, ролі, Digest, Документи, Сповіщення, Audit-log, мобільний додаток.',
    price: '€15 /user/міс',
    iconBg: '#1A1A1A',
    iconColor: '#fff',
    iconClass: 'ri-settings-3-line',
  },
  {
    id: 'forecast',
    code: 'M-01',
    name: 'Forecast',
    status: 'existing',
    badge: 'selected',
    description: 'AI прогноз СЕС, MAPE 8-15%, 15-хв, Open-Meteo + ECMWF + CAMS.',
    price: '€120 /станцію/міс',
    iconBg: '#B8860B',
    iconColor: '#fff',
    iconClass: 'ri-sun-line',
  },
  {
    id: 'dispatch',
    code: 'M-03',
    name: 'Dispatch',
    status: 'existing',
    badge: 'selected',
    description: 'Диспетчеризація, комунікація з Ukrenergo/ГарПок, MMS v5.1.',
    price: '€250 /станція',
    iconBg: '#1F5B8F',
    iconColor: '#fff',
    iconClass: 'ri-broadcast-line',
  },
  {
    id: 'reports',
    code: 'M-06',
    name: 'Reports',
    status: 'existing',
    badge: 'selected',
    description: 'Звіти, KPI дашборди, експорт Excel/PDF, email-розсилка.',
    price: '€100 /компанія/міс',
    iconBg: '#6B4FC8',
    iconColor: '#fff',
    iconClass: 'ri-bar-chart-2-line',
  },
  {
    id: 'heliosops',
    code: 'M-09',
    name: 'HeliosOps ★',
    status: 'new',
    badge: 'trial',
    description: 'Work-orders, тікети ТО, мобільний додаток для бригад, ETAs, фото-звіти.',
    price: '€150 /МВт/міс',
    iconBg: '#C87A1A',
    iconColor: '#fff',
    iconClass: 'ri-tools-line',
  },
  {
    id: 'bess',
    code: 'M-02',
    name: 'BESS / Заряд',
    status: 'existing',
    badge: 'available',
    description: 'Оптимізація зарядки, арбітраж РДН, 24/7 managed service.',
    price: '€350 /МВт/міс',
    iconBg: '#0D7A3C',
    iconColor: '#fff',
    iconClass: 'ri-battery-charge-line',
  },
  {
    id: 'trade',
    code: 'M-04',
    name: 'Trade',
    status: 'existing',
    badge: 'available',
    description: 'Торгівля на РДН/ВДР, автоматичні заявки, аналіз ринку.',
    price: '€200 /МВт/міс',
    iconBg: '#2E86AB',
    iconColor: '#fff',
    iconClass: 'ri-stock-line',
  },
  {
    id: 'go',
    code: 'M-05',
    name: 'GO Сертифікати',
    status: 'existing',
    badge: 'available',
    description: 'Облік та продаж гарантій походження, інтеграція з AIB.',
    price: '€80 /компанія/міс',
    iconBg: '#3D7A3D',
    iconColor: '#fff',
    iconClass: 'ri-shield-check-line',
  },
  {
    id: 'askoe',
    code: 'M-07',
    name: 'АСКОЕ',
    status: 'existing',
    badge: 'available',
    description: 'Автоматизований облік електроенергії, інтеграція з лічильниками.',
    price: '€180 /станцію/міс',
    iconBg: '#8B4513',
    iconColor: '#fff',
    iconClass: 'ri-plug-line',
  },
];

export const wizardIntegrations: WizardIntegration[] = [
  {
    id: 'ukrenergo',
    name: 'Ukrenergo',
    category: 'Балансування',
    description: 'Подача планових графіків балансування до НЕК Укренерго через MMS API.',
    logoClass: 'ri-flashlight-line',
    logoBg: '#1F5B8F',
    logoColor: '#fff',
    connected: false,
    recommended: true,
  },
  {
    id: 'garpok',
    name: 'ГарПок',
    category: 'Розрахунки',
    description: 'Інтеграція з Гарантованим Покупцем для автоматизованих розрахунків.',
    logoClass: 'ri-bank-line',
    logoBg: '#2E7D32',
    logoColor: '#fff',
    connected: false,
    recommended: true,
  },
  {
    id: 'ecmwf',
    name: 'ECMWF',
    category: 'Метеодані',
    description: 'Прогнози погоди Євро-моделі для точного прогнозування генерації.',
    logoClass: 'ri-cloud-windy-line',
    logoBg: '#0277BD',
    logoColor: '#fff',
    connected: false,
    recommended: true,
  },
  {
    id: 'openmeteo',
    name: 'Open-Meteo',
    category: 'Метеодані',
    description: 'Безкоштовний API метеопрогнозів з глобальним покриттям та 15-хв оновленням.',
    logoClass: 'ri-sun-cloudy-line',
    logoBg: '#E65100',
    logoColor: '#fff',
    connected: true,
    recommended: false,
  },
  {
    id: 'cams',
    name: 'CAMS Copernicus',
    category: 'Інсоляція',
    description: 'Супутникові дані сонячної радіації від Copernicus Atmosphere Monitoring Service.',
    logoClass: 'ri-earth-line',
    logoBg: '#283593',
    logoColor: '#fff',
    connected: false,
    recommended: false,
  },
  {
    id: 'telegram',
    name: 'Telegram Bot',
    category: 'Сповіщення',
    description: 'Автоматичні сповіщення про відхилення, алерти та дайджест у Telegram.',
    logoClass: 'ri-telegram-line',
    logoBg: '#0088CC',
    logoColor: '#fff',
    connected: false,
    recommended: false,
  },
  {
    id: 'googledrive',
    name: 'Google Drive',
    category: 'Документи',
    description: 'Автоматичне збереження звітів та документів у Google Drive.',
    logoClass: 'ri-folder-cloud-line',
    logoBg: '#34A853',
    logoColor: '#fff',
    connected: false,
    recommended: false,
  },
  {
    id: 'sap',
    name: 'SAP / ERP',
    category: 'Облік',
    description: 'Інтеграція з корпоративними ERP-системами для бухгалтерського обліку.',
    logoClass: 'ri-database-2-line',
    logoBg: '#1565C0',
    logoColor: '#fff',
    connected: false,
    recommended: false,
  },
  {
    id: 'api',
    name: 'REST API',
    category: 'Розробникам',
    description: 'Власний API-токен для інтеграції з вашими внутрішніми системами.',
    logoClass: 'ri-code-s-slash-line',
    logoBg: '#4A4A4A',
    logoColor: '#fff',
    connected: false,
    recommended: false,
  },
];

export type WizardProfileData = {
  firstName: string;
  lastName: string;
  phone: string;
  position: string;
  timezone: string;
  language: string;
};

export type WizardCompanyData = {
  name: string;
  edrpou: string;
  address: string;
  city: string;
  type: string;
  capacity: string;
  website: string;
  timezone: string;
};

export type TeamMember = {
  id: string;
  name: string;
  email: string;
  role: string;
};

export type WizardData = {
  profile: WizardProfileData;
  company: WizardCompanyData;
  selectedModules: string[];
  selectedIntegrations: string[];
  team: TeamMember[];
};

export const defaultWizardData: WizardData = {
  profile: {
    firstName: '',
    lastName: '',
    phone: '',
    position: '',
    timezone: 'Europe/Kiev',
    language: 'uk',
  },
  company: {
    name: '',
    edrpou: '',
    address: '',
    city: '',
    type: 'СЕС',
    capacity: '',
    website: '',
    timezone: 'Europe/Kiev',
  },
  selectedModules: ['core', 'forecast', 'dispatch', 'reports'],
  selectedIntegrations: ['openmeteo'],
  team: [],
};
